import React, { useState } from "react";
import "./FAQ.css";
import last2 from "../Assets/last2.jpg";

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      question: "What is the WING P Collection?",
      answer: "The WING P Collection is a premium athletic sneaker NFT series inspired by the Peregrine Falcon. Each NFT represents a unique piece of aerodynamic artistry, featuring premium leather construction, Talon-Lock lacing system, and dual-density foam core technology. This collection combines athletic performance with blockchain innovation, offering 10 unique designs with 1000 supply each."
    },
    {
      question: "How do I mint a WING P NFT?",
      answer: "To mint a WING P NFT, simply connect your digital wallet, browse our collection, and select your desired sneaker design. Each NFT costs $150 (in ETH equivalent) and can be minted directly through our marketplace. The minting process is secure, fast, and user-friendly with support for all major wallet providers."
    },
    {
      question: "What makes WING P sneakers special?",
      answer: "WING P sneakers feature revolutionary design elements including a sweeping, layered wing motif crafted from premium leather, Lycra lining for a second-skin fit, and a Talon-Lock lacing system for custom grip. The sole features intricate, feather-line treads designed for maximum traction. Each pair represents the perfect fusion of style, sustainability, and athletic performance."
    },
    {
      question: "What is the supply and pricing structure?",
      answer: "Our ERC1155 contract features 10 unique sneaker designs, with each design having a supply of 1000 NFTs. The minting price is $150 per NFT (paid in ETH equivalent). This limited supply ensures exclusivity while maintaining accessibility for our community of athletic enthusiasts and NFT collectors."
    },
    {
      question: "Are there any utility benefits for NFT holders?",
      answer: "Yes! WING P NFT holders gain access to exclusive benefits including early access to new collections, special edition physical sneaker drops, community events, and potential future airdrops. Holders also become part of an elite community of athletes and fashion-forward individuals who share the vision of revolutionizing athletic fashion through innovation and style."
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="main_FAQ" id="FAQ">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <h6 className="faq_nft">FAQ Falco P</h6>
            <h1 className="FAQ_head">
              Frequently <br /> asked question
            </h1>
            <p className="faq_text robo_font">
              Everything you need to know about the Falco P sneaker collection. 
              From minting to utility, get answers to the most common questions about our premium athletic NFTs.
            </p>
            <img src={last2} className="pos_fa" alt="Falco P Collection" />
          </div>
          <div className="col-md-6 mt-3 mt-md-0">
            <div className="custom_accordion">
              {faqData.map((item, index) => (
                <div key={index} className="accordion_item">
                  <div 
                    className={`accordion_header ${activeIndex === index ? 'active' : ''}`}
                    onClick={() => toggleAccordion(index)}
                  >
                    <h3 className="accordion_question robo_font">{item.question}</h3>
                    <span className="accordion_icon">
                      {activeIndex === index ? '−' : '+'}
                    </span>
                  </div>
                  {activeIndex === index && (
                    <div className="accordion_content">
                      <p className="acc_para robo_font">{item.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
